import React from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import InvitationPublication from './components/InvitationPublication'
import styles from './EmailNotifications.module.scss'
import ReminderAutomated from './components/ReminderAutomated'

interface Props {
  isNewCourse?: boolean
  disableReminder?: boolean
}

const EmailNotifications: React.FC<Props> = ({ isNewCourse, disableReminder }) => {
  const { t } = useTranslation()

  return (
    <>
      <Form.Group
        className={classNames('border-top mt-3 pt-3', styles.notifications)}
      >
        <div
          className={classNames('blue-darken font-weight-bold', styles.title)}
        >
          {t('administration.courses.new.form.notifications.title')}
        </div>
        <InvitationPublication isNewCourse={isNewCourse} invitationsDisabled={disableReminder}/>
        <hr className="my-2" />
        <ReminderAutomated disabled={disableReminder} />
        <hr className="my-2" />
      </Form.Group>
    </>
  )
}

export default EmailNotifications
